<template>
<div>
    <div class="body-2 font-weight-medium primary--text text-left text-sm-right mt-2">{{text}}</div>
    <div v-if="desc" class="text-left text-sm-right grey--text text--darken-1 caption" style="line-height:1.2">{{desc}}</div>
</div>
</template>

<script>
export default {
    data: () => ({

    }),
    props: ['text', 'desc']
}
</script>